import axiosInstance from "@/axiosInstance";
import { isExpired } from "@/auth/token";

export default {
  state: {
    token: undefined,
    user: undefined,
    logoutReason: undefined,
  },
  mutations: {
    token(state, token) {
      state.token = token;
      axiosInstance.defaults.headers.common["Authorization"] =
        "Bearer " + token;
      localStorage.setItem("token", token);
    },
    user(state, user) {
      state.user = user;
      localStorage.setItem("user", JSON.stringify(user));
    },
    clearAll(state) {
      state.token = undefined;
      state.user = undefined;
      axiosInstance.defaults.headers.common["Authorization"] = null;
      localStorage.removeItem("token");
      localStorage.removeItem("user");
    },
  },
  actions: {
    init({ commit }) {
      try {
        let storedToken = localStorage.getItem("token");
        if (storedToken) commit("token", storedToken);
        let storedUser = localStorage.getItem("user");
        if (storedUser) commit("user", JSON.parse(storedUser));
      } catch {
        commit("clearAll");
        window.location.replace("/anmelden");
      }
    },
    login({ commit }, credentials) {
      commit("loading", true, { root: true });
      return axiosInstance
        .post("/login", credentials)
        .then((response) => {
          commit("token", response.data);
          axiosInstance
            .get("/users", {
              params: {
                username: credentials.username,
              },
            })
            .then((response) => {
              commit("user", response.data[0]);
            });
        })
        .finally(() => commit("loading", false, { root: true }));
    },
    logout({ commit }, reason = null) {
      commit("clearAll");
      if (reason) sessionStorage.setItem("logoutReason", reason);
      window.location.replace("/anmelden");
    },
    changePassword({ state, commit }, passwordObj) {
      return axiosInstance
        .post(`/users/${state.user.id}/password`, passwordObj)
        .then((response) => {
          commit("user", response.data);
        });
    },
    authenticationFailed() {
      // console.log('authentication failed')
    },
  },
  getters: {
    loggedIn(state) {
      return !!state.token && !isExpired(state.token);
    },
    user(state) {
      return state.user;
    },
    readyToUse(state, getters) {
      return getters.loggedIn && !state.user?.credentials?.initial;
    },
  },
};
